import { ShippingAddress } from "common/api/decimal/methods/course";
import { FormattedMessage } from "react-intl";
import styles from "./TermOrdersCopy.module.scss";

const getFormattedMessageValues = ({
  address,
  studentEmail,
}: {
  address?: ShippingAddress;
  studentEmail?: string;
}) => ({
  address: () => (
    <span className={styles.address}>
      {[
        address?.addressLine1,
        address?.addressLine2 ? address?.addressLine2 : undefined,
        `${address?.city},`,
        address?.state,
        address?.zip,
      ]
        .filter(Boolean)
        .join(" ")}
    </span>
  ),
  studentEmail,
});

export type TermOrderBannerVariant =
  | "confirm shipping address"
  | "add shipping address"
  | "return items"
  | "return items campus";

export default function TermOrdersCopy({
  variant,
  type,
  values,
}: {
  variant: TermOrderBannerVariant;
  type: "title" | "content" | "cta";
  values?: {
    address?: ShippingAddress;
    studentEmail?: string;
    count?: number;
  };
}) {
  if (variant === "confirm shipping address") {
    switch (type) {
      case "title":
        return (
          <FormattedMessage defaultMessage="Confirm Your Shipping Address" />
        );
      case "content":
        return (
          <FormattedMessage
            defaultMessage="Physical items are being shipped to: <address></address>"
            values={getFormattedMessageValues({
              address: values?.address,
            })}
          />
        );
      case "cta":
        return <FormattedMessage defaultMessage="Update" />;
    }
  }
  if (variant === "add shipping address") {
    switch (type) {
      case "title":
        return <FormattedMessage defaultMessage="Add Shipping Address" />;
      case "content":
        return (
          <FormattedMessage defaultMessage="Add a shipping address to receive your materials on time and at the right place." />
        );
      case "cta":
        return <FormattedMessage defaultMessage="Add Address" />;
    }
  }
  if (variant === "return items") {
    switch (type) {
      case "title":
        return <FormattedMessage defaultMessage="Return Items" />;
      case "content":
        return (
          <FormattedMessage
            defaultMessage="{count, plural, one {You have # item that needs to be returned.} other {You have # items that need to be returned.}} An email was sent to {studentEmail} with your shipping label for return."
            values={{
              count: values?.count,
              studentEmail: values?.studentEmail,
            }}
          />
        );
      case "cta":
        return <FormattedMessage defaultMessage="View Details" />;
    }
  }
  if (variant === "return items campus") {
    switch (type) {
      case "title":
        return <FormattedMessage defaultMessage="Return Items" />;
      case "content":
        return (
          <FormattedMessage
            defaultMessage="{count, plural, one {You have # item that needs to be returned.} other {You have # items that need to be returned.}} An email was sent to {studentEmail} with the return location details. Please note, the return location may be different from the pickup location."
            values={{
              count: values?.count,
              studentEmail: values?.studentEmail,
            }}
          />
        );
      case "cta":
        return <FormattedMessage defaultMessage="View Details" />;
    }
  }
}
